import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, Box } from "@mui/material";
import { getProfileId } from "../../actions/profile";
import { getUserbyId } from "../../actions/users";
import ProfileHeader from "../../components/user/publicProfile/ProfileHeader";
import ProfileSidebar from "../../components/user/publicProfile/ProfileSidebar";
import ProfileServiceList from "../../components/user/publicProfile/ProfileServiceList";
import ProfileProvidersList from "../../components/user/publicProfile/ProfileProvidersList";
import { Loading } from "../../components/common/Loading";

const PublicProfile = () => {
  const { idUsuario } = useParams();
  const [profile, setProfile] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [profileData, userData] = await Promise.all([
          getProfileId(idUsuario),
          getUserbyId(idUsuario)
        ]);
        setProfile(profileData);
        setUser(userData);
      } catch (error) {
        console.error("Error fetching public profile data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (idUsuario) {
      fetchData();
    }
  }, [idUsuario]);

  if (loading) {
    return <Loading />;
  }

  return (
    <Box className="public-profile-container" sx={{ mt: 13, mb: 8 }}>
      <ProfileHeader user={user} />

      <Grid container spacing={4} sx={{ mt: 2 }}>
        {/* Left Sidebar */}
        <Grid size={{ xs: 12, md: 4, lg: 3.5 }}>
          <ProfileSidebar user={user} profile={profile} />
        </Grid>

        {/* Right Content Area */}
        <Grid size={{ xs: 12, md: 8, lg: 8.5 }}>
          <Box className="profile-content-right" sx={{ pl: { md: 2 } }}>
            <ProfileServiceList profile={profile} user={user} />
          </Box>
        </Grid>
      </Grid>
      
      {/* Related Providers Module */}
      <ProfileProvidersList currentUserId={idUsuario} />
    </Box>
  );
};

export default PublicProfile;
